/**
 * EmptyState — état vide « invitation » (refresh design, 2026-07).
 * Remplace les boîtes border-dashed grises : pastille de marque + message
 * chaleureux + CTA optionnel. Un vide doit inviter, pas décourager.
 */
import * as React from "react";
import { cn } from "../../lib/utils";

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
  iconGradient = "var(--grad-signature)",
}: {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
  /** Dégradé de la pastille d'icône — pour teinter l'état vide à la couleur du domaine. */
  iconGradient?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center text-center rounded-2xl border px-6 py-10",
        className,
      )}
      style={{
        borderColor: "color-mix(in srgb, var(--color-kestio-violet) 22%, transparent)",
        background: "color-mix(in srgb, var(--color-kestio-violet) 5%, var(--card))",
      }}
    >
      {icon != null && (
        <div
          className="flex h-14 w-14 items-center justify-center rounded-2xl text-white text-2xl mb-3"
          style={{ backgroundImage: iconGradient, boxShadow: "var(--elev-2)" }}
        >
          {icon}
        </div>
      )}
      <h3 className="font-semibold" style={{ color: "var(--color-kestio-blue)", fontFamily: "Sora, sans-serif" }}>
        {title}
      </h3>
      {description && <p className="mt-1 text-sm text-muted-foreground max-w-sm">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
